import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthenticationService } from '@modules/authentication/services/authentication.service';
import { AuthAppRedirectService } from '@services/auth-app-redirect.service';

export const mustChangePasswordGuard: CanActivateFn = () => {
  const { user } = inject(AuthenticationService);

  if (!user) {
    return false;
  }

  // Logout, not login: the auth app sends a still-signed-in user straight back here, which would loop.
  if (user.mustChangePassword) {
    inject(AuthAppRedirectService).logout();
    return false;
  }

  return true;
};
